exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-16b394de] .el-table__body-wrapper{height:500px;overflow-y:auto}[data-v-16b394de]::-webkit-scrollbar-thumb{-webkit-box-shadow:inset 0 0 6px #ccc}[data-v-16b394de]::-webkit-scrollbar{width:4px !important}.avatar[data-v-16b394de]{width:40px;height:40px}\n", ""]);

// exports
